import { useState } from 'react';

import { FormControlLength } from '../FormControl';

import { Input } from './Input';
import type { InputTextFieldProps } from './InputTextField';

export type InputTextFieldLengthProps = {
	maxLength: number;
} & InputTextFieldProps;

/**
 * Input with helper text displaying current length of the input value.
 * Sets error when length is past the max length.
 *
 * NOTE: Expects current input value to be passed in via `value` prop
 */
export function InputTextFieldLength({
	label,
	helperText,
	error,
	outerStyle,
	maxLength,
	...other
}: InputTextFieldLengthProps) {
	const [isFocused, setIsFocused] = useState(false);

	return (
		<FormControlLength
			label={label}
			helperText={helperText}
			error={error}
			outerStyle={outerStyle}
			value={other.value}
			maxLength={maxLength}
			showLength={isFocused}
		>
			<Input
				error={error}
				{...other}
				onFocus={(e) => {
					other.onFocus?.(e);
					setIsFocused(true);
				}}
				onBlur={(e) => {
					other.onBlur?.(e);
					setIsFocused(false);
				}}
			/>
		</FormControlLength>
	);
}
